import event from '@/fn/event'

/**
 * 主动调用父框架的方法
 */
const callParant = (type: string, ...params: any[]) => {
  try {
    const iframe = window.parent as any
    const intent = iframe && iframe.vueEmbedIntent
    const result = intent && intent(type, ...params)
    return result
  } catch (ex) {
    // tslint:disable-next-line: no-console
    console.error(ex)
  }
}

const syncHeight = () => {
  const height = document.body.scrollHeight
  callParant('updateHeight', height)
}

let hasListenHeight = false
const listenHeight = () => {
  hasListenHeight || ['resize', 'load'].forEach(type => {
    window.addEventListener(type, syncHeight)
  })
  hasListenHeight = true
}

export function updateHeight() {
  syncHeight()
  listenHeight()
}

export function gotoRoute(link: string) {
  callParant('gotoRoute', link)
}

export function getPlayList(): any[] {
  const list = callParant('getPlayList') || []
  return list
}

export function savePlayList(list: any[]) {
  callParant('savePlayList', list)
}

export function getDeviceList(): any[] {
  const list = callParant('getDeviceList') || []
  return list
}

export function getProps() {
  return callParant('getProps')
}

/**
 * 被动监听父框架的事件
 */
export function initInbox() {
  // 定义一个全局方法，供父框架调用
  (window as any).embedInbox = (type: string, data: any = {}) => {
    // 从父框架接收过来的消息，被 event 发出为 @type 事件

    // 事件监听函数，可以通过设置 result 返回数据
    const intent = {
      data,
      result: undefined,
    }

    event.emit(`@${type}`, intent)

    return intent.result
  }
}

/**
 * 判断页面是否被嵌入 iframe
 */
export function isEmbed() {
  return window != window.top
}
